class ListAccordions extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.resetButton = this.querySelector('[data-filters-reset]');
    this.scrollLinks = this.querySelectorAll('[data-scroll-link]');
    this.sections = this.querySelectorAll('[data-section]');
    this.sectionActiveIndex = 0;
    this.status = this.querySelector('[data-status]');
    this.dropdownLabel = this.querySelector('[data-dropdown-label]');
    this.accordions = this.querySelectorAll('[data-filter-item]');
    this.locales = JSON.parse(this.querySelector('[data-locales]').textContent);
    this.resetButton?.addEventListener(
      'click',
      this.handleResetClick.bind(this),
    );
    this.addEventListener('input', this.handleFilterChange.bind(this));
    this.scrollLinks.forEach((link) => {
      link.addEventListener('click', this.handleScrollLinkClick.bind(this));
    });
    window.addEventListener('scroll', this.handleScrollSpy.bind(this));
  }

  handleResetClick(event) {
    event.preventDefault();

    this.querySelectorAll('[data-filter]:checked').forEach((filter) => {
      filter.checked = false;
    });
    this.setActiveItems([]);
    this.setDropdownLabel([]);
  }

  handleFilterChange() {
    const activeFilters = Array.from(
      this.querySelectorAll('[data-filter]:checked'),
    ).map(({ name, value }) => ({ name, value }));

    this.setActiveItems(activeFilters);
    this.setDropdownLabel(activeFilters);
  }

  setActiveItems(filters) {
    if (filters.length === 0) {
      this.accordions.forEach((accordion) =>
        accordion.classList.remove('hidden'),
      );
      this.setStatus(filters);

      return;
    }

    const activeFiltersValues = filters.map((filter) => filter.value);

    this.accordions.forEach((accordion) => {
      accordion.classList.toggle(
        'hidden',
        !activeFiltersValues.includes(accordion.dataset.filterHandle),
      );
    });

    const activeItems = Array.from(this.accordions).filter(
      (accordion) => !accordion.classList.contains('hidden'),
    );

    this.setStatus(filters, activeItems);
  }

  setDropdownLabel(filters) {
    if (filters.length === 0) {
      return (this.dropdownLabel.textContent = this.locales.all);
    }

    if (filters.length > 1) {
      return (this.dropdownLabel.textContent = this.locales.selected_more
        .replace('{{ name }}', filters[0].name)
        .replace('{{ count }}', filters.length - 1));
    }

    return (this.dropdownLabel.textContent = filters[0].name);
  }

  setStatus(filters, activeItems) {
    if (filters.length === 0) {
      return (this.status.textContent = '');
    }

    if (filters.length > 1) {
      return (this.status.textContent = this.locales.showing_multiple.replace(
        '{{ count }}',
        activeItems.length,
      ));
    }

    return (this.status.textContent = this.locales.showing_single
      .replace('{{ count }}', activeItems.length)
      .replace('{{ name }}', filters[0].name));
  }

  handleScrollLinkClick(event) {
    event.preventDefault();

    const target = document.querySelector(event.target.getAttribute('href'));

    if (!target) {
      return;
    }

    const isMobileDevice = window.matchMedia('(max-width: 749px)').matches;
    const stickyOffset = target === document.body || !isMobileDevice ? 0 : 137; // header + top bar + sticky filters
    const offsetTop =
      target.getBoundingClientRect().top + window.scrollY - stickyOffset;

    window.scrollTo({
      top: offsetTop,
      left: 0,
    });
  }

  toggleActiveLink(link, flag = false) {
    return this.scrollLinks[link].classList.toggle('is-active', flag);
  }

  unsetAllActiveLinks() {
    return [...Array(this.sections.length).keys()].forEach((link) =>
      this.toggleActiveLink(link),
    );
  }

  handleScrollSpy() {
    const sectionMargin = 200;
    const current =
      this.sections.length -
      [...this.sections]
        .reverse()
        .findIndex(
          (section) => window.scrollY >= section.offsetTop - sectionMargin,
        ) -
      1;

    if (current !== this.sectionActiveIndex) {
      this.unsetAllActiveLinks();
      this.sectionActiveIndex = current;
      this.toggleActiveLink(current, true);
    }
  }
}

customElements.define('list-accordions', ListAccordions);
